import {navigateToGroup} from '../../../../commons/services/navigation'
import {getEvent} from '../selectors/event'
import {getGroupId, getGroupSlug} from '../selectors/groups'
import {createAsyncAction} from '../services/redux-toolkit'

export const getConnectedGroup = createAsyncAction(
  'GET_CONNECTED_GROUP',
  async (_, {getState, dispatch, extra: {serverApi}}) => {
    const eventId = getEvent(getState()).id

    if (eventId && !eventId.includes('demo')) {
      const response = await serverApi.getGroup(eventId)

      if (response && response.group?.id) {
        await dispatch(getGroupActivity(response.group.id))
      }

      return response
    }
  },
)

export const getGroupActivity = createAsyncAction('GET_GROUP_ACTIVITY', async (groupId: string, {extra: {serverApi}}) =>
  serverApi.getGroupActivity(groupId),
)

export const joinGroup = createAsyncAction('JOIN_GROUP', async (_, {getState, extra: {wixCodeApi}}) => {
  const state = getState()
  const groupId = getGroupId(state)
  const slug = getGroupSlug(state)

  await navigateToGroup(slug, groupId, wixCodeApi)
})
